import { render } from "./About.vue?vue&type=template&id=a25e2782"
const script = {}
script.render = render

export default script